

// import React from "react";
// import { Link, useLocation } from "react-router-dom";


// const serviceAreas = [
//   {
//     label: "Öveçler Halı Yıkama",
//     path: "/cankaya/ovecler-hali-yikama",
//     description: "Öveçler bölgesine özel hizmetimizde, antibakteriyel şampuanlarla derinlemesine halı temizliği sunuyoruz. Kapıdan alım ve teslimat ücretsizdir."
//   },
//   {
//     label: "Dikmen Halı Yıkama",
//     path: "/cankaya/dikmen-hali-yikama",
//     description: "Dikmen sakinlerine özel halı yıkama servisimizle hijyenik, garantili ve zamanında teslim sağlıyoruz."
//   },
//   {
//     label: "Bahçelievler Halı Yıkama",
//     path: "/cankaya/bahcelievler-hali-yikama",
//     description: "Bahçelievler bölgesinde halılarınızı organik ürünlerle temizliyor, ilk günkü gibi teslim ediyoruz."
//   },
//   {
//     label: "Oran Halı Yıkama",
//     path: "/cankaya/oran-hali-yikama",
//     description: "Oran'da modern makineler ve uzman kadromuzla halı yıkama hizmeti sunuyoruz."
//   },
//   {
//     label: "Emek Halı Yıkama",
//     path: "/cankaya/emek-hali-yikama",
//     description: "Emek bölgesinde halılarınız özenle yıkanır, steril paketle teslim edilir."
//   },
//   {
//     label: "Balgat Halı Yıkama",
//     path: "/cankaya/balgat-hali-yikama",
//     description: "Balgat'a özel servisle halılarınız hijyenik şekilde yıkanır, zamanında teslim edilir."
//   },
//   {
//     label: "Çukurambar Halı Yıkama",
//     path: "/cankaya/cukurambar-hali-yikama",
//     description: "Çukurambar sakinlerine profesyonel, uygun fiyatlı halı yıkama çözümleri sunuyoruz."
//   },
//   {
//     label: "Çayyolu Halı Yıkama",
//     path: "/cankaya/cayyolu-hali-yikama",
//     description: "Çayyolu bölgesine özel ücretsiz servis ve hijyen garantili halı temizliği hizmeti."
//   },
//   {
//     label: "Beytepe Halı Yıkama",
//     path: "/cankaya/beytepe-hali-yikama",
//     description: "Beytepe’de antibakteriyel ürünlerle etkili ve sağlıklı halı yıkama."
//   },
//   {
//     label: "Yaşamkent Halı Yıkama",
//     path: "/cankaya/yasamkent-hali-yikama",
//     description: "Yaşamkent Halı Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Ümitköy Halı Yıkama",
//     path: "/cankaya/umitkoy-hali-yikama",
//     description: "Ümitköy Halı Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Beysukent Halı Yıkama",
//     path: "/cankaya/beysukent-hali-yikama",
//     description: "Beysukent Halı Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Bilkent Halı Yıkama",
//     path: "/cankaya/bilkent-hali-yikama",
//     description: "Bilkent Halı Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Öveçler Koltuk Yıkama",
//     path: "/cankaya/ovecler-koltuk-yikama",
//     description: "Öveçler Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Dikmen Koltuk Yıkama",
//     path: "/cankaya/dikmen-koltuk-yikama",
//     description: "Dikmen Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Bahçelievler Koltuk Yıkama",
//     path: "/cankaya/bahcelievler-koltuk-yikama",
//     description: "Bahçelievler Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Oran Koltuk Yıkama",
//     path: "/cankaya/oran-koltuk-yikama",
//     description: "Oran Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Emek Koltuk Yıkama",
//     path: "/cankaya/emek-koltuk-yikama",
//     description: "Emek Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Balgat Koltuk Yıkama",
//     path: "/cankaya/balgat-koltuk-yikama",
//     description: "Balgat Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Çukurambar Koltuk Yıkama",
//     path: "/cankaya/cukurambar-koltuk-yikama",
//     description: "Çukurambar Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Çayyolu Koltuk Yıkama",
//     path: "/cankaya/cayyolu-koltuk-yikama",
//     description: "Çayyolu Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Beytepe Koltuk Yıkama",
//     path: "/cankaya/beytepe-koltuk-yikama",
//     description: "Beytepe Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Yaşamkent Koltuk Yıkama",
//     path: "/cankaya/yasamkent-koltuk-yikama",
//     description: "Yaşamkent Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Ümitköy Koltuk Yıkama",
//     path: "/cankaya/umitkoy-koltuk-yikama",
//     description: "Ümitköy Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Beysukent Koltuk Yıkama",
//     path: "/cankaya/beysukent-koltuk-yikama",
//     description: "Beysukent Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Bilkent Koltuk Yıkama",
//     path: "/cankaya/bilkent-koltuk-yikama",
//     description: "Bilkent Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
//   },
//   {
//     label: "Çankaya Tüm Semtler",
//     path: "/cankaya/tum-semtler",
//     description: "Çankaya ilçesindeki tüm semtlere hizmet veriyoruz. Halı, koltuk, stor ve yorgan yıkama alanında uzmanız."
//   }
// ];

// const CankayaSidebar = () => {
//   const location = useLocation();

//   return (
//     <div className="mt-2 text-[#003132]">
//       <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">ÇANKAYA SERVİS BÖLGELERİ</h2>
//       <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
//         {serviceAreas.map((area, index) => (
//           <div key={index}>
//             <Link
//               to={area.path}
//               className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
//                 location.pathname === area.path
//                   ? "bg-red-600 text-white"
//                   : "text-red-900 hover:bg-green-100 hover:text-red-800"
//               }`}
//             >
//               {area.label}
//             </Link>
//             <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CankayaSidebar;
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const serviceAreas = [
  {
    label: "Öveçler Halı Yıkama",
    path: "/cankaya/ovecler-hali-yikama",
    description: "Öveçler bölgesine özel hizmetimizde, antibakteriyel şampuanlarla derinlemesine halı temizliği sunuyoruz. Kapıdan alım ve teslimat ücretsizdir."
  },
  {
    label: "Dikmen Halı Yıkama",
    path: "/cankaya/dikmen-hali-yikama",
    description: "Dikmen sakinlerine özel halı yıkama servisimizle hijyenik, garantili ve zamanında teslim sağlıyoruz."
  },
  {
    label: "Bahçelievler Halı Yıkama",
    path: "/cankaya/bahcelievler-hali-yikama",
    description: "Bahçelievler bölgesinde halılarınızı organik ürünlerle temizliyor, ilk günkü gibi teslim ediyoruz."
  },
  {
    label: "Oran Halı Yıkama",
    path: "/cankaya/oran-hali-yikama",
    description: "Oran'da modern makineler ve uzman kadromuzla halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Emek Halı Yıkama",
    path: "/cankaya/emek-hali-yikama",
    description: "Emek bölgesinde halılarınız özenle yıkanır, steril paketle teslim edilir."
  },
  {
    label: "Balgat Halı Yıkama",
    path: "/cankaya/balgat-hali-yikama",
    description: "Balgat'a özel servisle halılarınız hijyenik şekilde yıkanır, zamanında teslim edilir."
  },
  {
    label: "Çukurambar Halı Yıkama",
    path: "/cankaya/cukurambar-hali-yikama",
    description: "Çukurambar sakinlerine profesyonel, uygun fiyatlı halı yıkama çözümleri sunuyoruz."
  },
  {
    label: "Çayyolu Halı Yıkama",
    path: "/cankaya/cayyolu-hali-yikama",
    description: "Çayyolu bölgesine özel ücretsiz servis ve hijyen garantili halı temizliği hizmeti."
  },
  {
    label: "Beytepe Halı Yıkama",
    path: "/cankaya/beytepe-hali-yikama",
    description: "Beytepe’de antibakteriyel ürünlerle etkili ve sağlıklı halı yıkama."
  },
  {
    label: "Yaşamkent Halı Yıkama",
    path: "/cankaya/yasamkent-hali-yikama",
    description: "Yaşamkent Halı Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Ümitköy Halı Yıkama",
    path: "/cankaya/umitkoy-hali-yikama",
    description: "Ümitköy Halı Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Beysukent Halı Yıkama",
    path: "/cankaya/beysukent-hali-yikama",
    description: "Beysukent Halı Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Bilkent Halı Yıkama",
    path: "/cankaya/bilkent-hali-yikama",
    description: "Bilkent Halı Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Öveçler Koltuk Yıkama",
    path: "/cankaya/ovecler-koltuk-yikama",
    description: "Öveçler Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Dikmen Koltuk Yıkama",
    path: "/cankaya/dikmen-koltuk-yikama",
    description: "Dikmen Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Bahçelievler Koltuk Yıkama",
    path: "/cankaya/bahcelievler-koltuk-yikama",
    description: "Bahçelievler Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Oran Koltuk Yıkama",
    path: "/cankaya/oran-koltuk-yikama",
    description: "Oran Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Emek Koltuk Yıkama",
    path: "/cankaya/emek-koltuk-yikama",
    description: "Emek Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Balgat Koltuk Yıkama",
    path: "/cankaya/balgat-koltuk-yikama",
    description: "Balgat Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Çukurambar Koltuk Yıkama",
    path: "/cankaya/cukurambar-koltuk-yikama",
    description: "Çukurambar Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Çayyolu Koltuk Yıkama",
    path: "/cankaya/cayyolu-koltuk-yikama",
    description: "Çayyolu Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Beytepe Koltuk Yıkama",
    path: "/cankaya/beytepe-koltuk-yikama",
    description: "Beytepe Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Yaşamkent Koltuk Yıkama",
    path: "/cankaya/yasamkent-koltuk-yikama",
    description: "Yaşamkent Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Ümitköy Koltuk Yıkama",
    path: "/cankaya/umitkoy-koltuk-yikama",
    description: "Ümitköy Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Beysukent Koltuk Yıkama",
    path: "/cankaya/beysukent-koltuk-yikama",
    description: "Beysukent Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Bilkent Koltuk Yıkama",
    path: "/cankaya/bilkent-koltuk-yikama",
    description: "Bilkent Koltuk Yıkama hizmetimizle kaliteli, güvenilir ve yerinde temizlik sunuyoruz."
  },
  {
    label: "Çankaya Tüm Semtler",
    path: "/cankaya/tum-semtler",
    description: "Çankaya ilçesindeki tüm semtlere hizmet veriyoruz. Halı, koltuk, stor ve yorgan yıkama alanında uzmanız."
  }
];

const CankayaSidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="mt-2 text-[#003132]">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          ÇANKAYA SERVİS BÖLGELERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="bg-[#f1f5f9] mt-2 p-4 rounded-xl shadow-sm space-y-3 border border-gray-200 max-h-[600px] overflow-y-auto">
          {serviceAreas.map((area, index) => (
            <div key={index}>
              <Link
                to={area.path}
                className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                  location.pathname === area.path
                    ? "bg-red-600 text-white"
                    : "text-red-900 hover:bg-green-100 hover:text-red-800"
                }`}
              >
                {area.label}
              </Link>
              <p className="text-xs text-gray-600 mt-1 pl-1">
                {area.description}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CankayaSidebar;
